import { Pipe, PipeTransform } from '@angular/core'
import * as moment from 'moment';
import { parseDate } from '../DateHelper';


@Pipe({
  name: 'todate'
})
export class ToDatePipe implements PipeTransform {
  transform(value: string) : Date {

    if (!value) {
      return null;
    }

    return parseDate(parseInt(value));
  }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/utils/pipes/todate.ts